import React from 'react';
import { useAuth } from '../auth/AuthContext';

const LicenseErrorPage = () => {
  const { logout } = useAuth();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white shadow-md rounded-md">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-semibold text-gray-800 mb-2">Account Inactive</h1>
          <div className="h-1 w-16 bg-gray-200 mx-auto"></div>
        </div>
        
        <div className="mb-6">
          <p className="text-gray-600 mb-4">
            Your account has been deactivated due to inactivity or unpaid invoice. 
            Please reach out to <a href="mailto:aman@gradewiz.ai" className="text-blue-600 hover:underline">aman@gradewiz.ai</a> to 
            reactivate your account.
          </p>
          <p className="text-gray-600">
            Sorry for the inconvenience and we hope to hear from you,
            <br />
            <span className="font-medium">The GradeWiz Team</span>
          </p>
        </div>
        
        <div className="text-center">
          <button
            onClick={logout}
            className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition duration-200"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default LicenseErrorPage;
